var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWhatsapp = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  id: "svg11",
  width: 16,
  height: 16,
  fill: "none",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("path", {
  id: "path2",
  fill: "url(#paint0_linear_259_10508)",
  d: "M8 0a8 8 0 1 1-4.02 14.92L0 16l1.08-3.97A8 8 0 0 1 8 0M5.27 4.24h-.16a.8.8 0 0 0-.3.09c-.08.05-.16.1-.23.18-.1.09-.15.17-.2.24-.3.39-.46.86-.46 1.35 0 .39.1.77.26 1.13.33.72.87 1.48 1.58 2.19l.52.5a7.56 7.56 0 0 0 3.07 1.64l.46.07.44-.01c.23-.02.46-.08.67-.19l.3-.17.1-.08c.11-.08.18-.13.27-.23a1 1 0 0 0 .17-.24c.06-.13.12-.38.15-.58v-.3a.24.24 0 0 0-.15-.21l-.46-.21s-.7-.3-1.12-.5a.4.4 0 0 0-.14-.03.38.38 0 0 0-.3.1c-.01 0-.06.04-.64.74a.28.28 0 0 1-.3.1.3.3 0 0 1-.15-.05l-.2-.08a4.8 4.8 0 0 1-1.26-.8l-.3-.28a5 5 0 0 1-.8-1.02l-.05-.07a.8.8 0 0 1-.09-.17c-.03-.11.05-.2.05-.2l.29-.34c.09-.1.16-.22.2-.3.1-.15.13-.3.08-.42-.22-.55-.45-1.1-.7-1.64-.04-.1-.18-.18-.3-.2a2.7 2.7 0 0 0-.46 0z",
  style: {
    fill: "url(#paint0_linear_259_10508)",
    strokeWidth: 0.959998
  }
}), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
  id: "defs9"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_259_10508",
  x1: 8.5,
  x2: 8.5,
  y1: 0.67,
  y2: 17.33,
  gradientTransform: "matrix(.96 0 0 .96 -.16 -.64)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  id: "stop4",
  stopColor: "#5BF674"
}), /*#__PURE__*/React.createElement("stop", {
  id: "stop6",
  offset: 1,
  stopColor: "#19C233"
})))));
export default SvgWhatsapp;